import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/arrow-left.svg")